import { Injectable } from '@angular/core';

/*
provider that holds the list of data that need to be parsed
Parses the data as per the settings
Works the data as per business rules
*/
@Injectable()
export class DataServiceProvider {
  requiredValues = [
    'Calculated load value',
    'Mass air flow rate',
    'Engine RPM',
    'Absolute throttle position',
    'Engine fuel rate',
    'Engine coolant temperature',
    'Commanded EGR',
    'EGR error',
  ];

  requiredItemKeys = [
    'calculatedLoadValue',
    'massAirFlowRate',
    'engineRpm',
    'absoluteThrottlePostion',
    'enginefuelRate',
    'engineCoolantTemperature',
    'commandedEGR',
    'egrError',
  ];

  // value shown will be improved on fav cases 
  // value shown will be optmised on non fav cases
  favorableRule = {
    calculatedLoadValue: 'Decreased',
    massAirFlowRate: 'Increased',
    engineRpm: 'Optimized',
    absoluteThrottlePostion: 'Decreased',
    enginefuelRate: 'Decreased',
  }

  // additional paramenters
  // inital and final values are not considered
  // rule : Only the intial value is show on the table 
  otherParams = ['Commanded EGR'
    , 'EGR error'];
  settingsArray: any[];
  items: any[]
  constructor() {
    this.items = [];
    this.initItem();
  }

  initItem() {
    this.items = [];
    this.settingsArray = []
    let index = 0;
    this.requiredValues.forEach(value => {
      this.items.push({
        title: value,
        initialValue: 0, finalValue: 0,
        unit: 'N.A',
        remark: 'N.A',
        key: this.requiredItemKeys[index],
        otherParameter: this.otherParams.indexOf(value) >= 0 ? true : false,
        //settingsValue: this.getSavedSettings(this.requiredItemKeys[index])
      });
      index++;
    });
  }

  /**
   * returns the items to show 
   */
  getItems() {
    return this.items;
  }
  fillFinalValues(records: any[], reportData: string[]) {
    let index = 0;
    records.forEach(record => {
      let object: any = {};
      object = this.getValueFromReport(reportData, records[index].title);
      records[index].finalValue = object.value;
      records[index].unit = object.unit;
      index = index + 1;
    });
  }
  /**
   * 
   */
  fillInitialValues(records: any[], reportData: string[]) {
    let index = 0;
    records.forEach(record => {
      let object: any = {};
      object = this.getValueFromReport(reportData, records[index].title);
      records[index].initialValue = object.value;
      records[index].unit = object.unit;
      index = index + 1;
    });
  }

  getValueFromReport(reportData: string[], parameter: string) {
    let result: any = {}
    switch (parameter) {
      // case 'Intake manifold absolute pressure':
      //   result.value = reportData[reportData.indexOf('Intake manifold absolute pressure') + 2];
      //   result.unit = reportData[reportData.indexOf('Intake manifold absolute pressure') + 3];
      //   return result;
      case 'Calculated load value':
        return this.getCalculatedLoadValue(reportData);
      case 'Mass air flow rate':
        return this.getMassAirFlowRate(reportData);
      case 'Absolute throttle position':
        return this.getAbsoluteThrottlePosition(reportData);
      case 'Engine RPM':
        return this.getEngineRpm(reportData);
      case 'Engine fuel rate':
        return this.getEngineFuelRate(reportData);
      case 'Engine coolant temperature':
        return this.getEngineCoolantTemperature(reportData);
      case 'Commanded EGR':
        return this.getCommandedEGR(reportData);
      case 'EGR error':
        return this.getEGRError(reportData);
      default:
        result.value = reportData.indexOf(parameter) < 0 ? 'Not Available' : +reportData[reportData.indexOf(parameter) + 1];
        result.unit = reportData.indexOf(parameter) < 0 ? '' : reportData[reportData.indexOf(parameter) + 2];
        return result;
    }
  }

  getEngineRpm(reportData) {
    let result: any = {};
    let dataIndex = 0;
    let index = 0;
    reportData.forEach((element: string) => {
      if (element.indexOf('Engine RPM') > -1 && dataIndex == 0) {
        dataIndex = index;
      }
      index++;
    });
    if (dataIndex > 0) {
      result.value = +this.getValueString(reportData[dataIndex]);
      result.unit = 'RPM';;
    } else {
      result.value = 'Not Available';
      result.unit = '';
    }
    return result;
  }

  getAbsoluteThrottlePosition(reportData) {
    let result: any = {};
    let dataIndex = 0;
    let index = 0;
    reportData.forEach((element: string) => {
      if (element.indexOf('Absolute throttle position') > -1 && dataIndex == 0) {
        dataIndex = index;
      }
      index++;
    });
    if (dataIndex > 0) {
      result.value = +this.getValueString(reportData[dataIndex]);
      result.unit = '%';;
    } else {
      result.value = 'Not Available';
      result.unit = '';
    }
    return result;
  }

  getCalculatedLoadValue(reportData: string[]) {
    let result: any = {};
    let dataIndex = 0;
    let index = 0;
    reportData.forEach((element: string) => {
      if (element.indexOf('Calculated load value') > -1 && dataIndex == 0) {
        dataIndex = index;
      }
      index++;
    });
    if (dataIndex > 0) {
      result.value = +this.getValueString(reportData[dataIndex]);
      result.unit = '%';;
    } else {
      result.value = 'Not Available';
      result.unit = '';
    }
    return result;
  }

  getMassAirFlowRate(reportData) {
    let result: any = {};
    let dataIndex = 0;
    let index = 0;
    reportData.forEach((element: string) => {
      if (element.indexOf('Mass air flow rate') > -1 && dataIndex == 0) {
        dataIndex = index;
      }
      index++;
    });
    if (dataIndex > 0) {
      result.value = +this.getValueString(reportData[dataIndex]);
      result.unit = 'g/s';;
    } else {
      result.value = 'Not Available';
      result.unit = '';
    }
    return result;
  }

  getEngineFuelRate(reportData) {
    let result: any = {};
    let dataIndex = 0;
    let index = 0;
    reportData.forEach((element: string) => {
      if (element.indexOf('Engine fuel rate') > -1 && dataIndex == 0) {
        dataIndex = index;
      }
      index++;
    });
    if (dataIndex > 0) {
      result.value = +this.getValueString(reportData[dataIndex]);
      result.unit = 'Ltr/Hr';;
    } else {
      result.value = 'Not Available';
      result.unit = '';
    }
    return result;
  }

  getEngineCoolantTemperature(reportData) {
    let result: any = {};
    let dataIndex = 0;
    let index = 0;
    reportData.forEach((element: string) => {
      if (element.indexOf('Engine coolant temperature') > -1 && dataIndex == 0) {
        dataIndex = index;
      }
      index++;
    });
    if (dataIndex > 0) {
      result.value = +this.getValueString(reportData[dataIndex]);
      result.unit = 'C';;
    } else {
      result.value = 'Not Available';
      result.unit = '';
    }
    return result;
  }

  getCommandedEGR(reportData) {
    let result: any = {};
    let dataIndex = 0;
    let index = 0;
    reportData.forEach((element: string) => {
      if (element.indexOf('Commanded EGR') > -1 && dataIndex == 0) {
        dataIndex = index;
      }
      index++;
    });
    if (dataIndex > 0) {
      result.value = +this.getValueString(reportData[dataIndex]);
      result.unit = '%';
    } else {
      result.value = 'Not Available';
      result.unit = '';
    }
    return result;
  }

  getEGRError(reportData) {
    let result: any = {};
    let dataIndex = 0;
    let index = 0;
    reportData.forEach((element: string) => {
      if (element.indexOf('EGR error') > -1 && dataIndex == 0) {
        dataIndex = index;
      }
      index++;
    });
    if (dataIndex > 0) {
      result.value = +this.getValueString(reportData[dataIndex]);
      result.unit = '%';
    } else {
      result.value = 'Not Available';
      result.unit = '';
    }
    return result;
  }

  getItemValue(reportData: string[], parameterIndex: number) {
    return reportData[parameterIndex + 1];
  }

  getItemUnit(reportData: string[], parameterIndex: number) {
    return reportData[parameterIndex + 2];
  }


  getRemarks(records: any[]) {

  }

  /**
   * returns the value of a parameater 
   * in the string 
   */
  getValueString(reportString: string): string {
    return reportString.substring(reportString.length - 80).replace(/[^-?\d+.]/g, '');
  }

  /**
   * get the settings from the cookies
   */
  getSavedSettings() {

    let settings = "{}";
    return settings ? JSON.parse(settings) : {};
  }

  /**
   * save Settings to cookies
   */
  saveSettings(settings) {
    // do nothing
  }




  getRecordRemark(item): string {
    // rule : dont show if there is no remarks (Data not avilable)
    if (item.remark == 'N.A') {
      return 'Dont Show';
    }
    // rule : parameter not in the scope of summary
    if (!this.favorableRule[item.key]) {
      return 'Dont Show';
    }
    else {
      return (item.remark == this.favorableRule[item.key]) ? 'Improved' : 'Optimized';
    }
  }

  /**
   * Returns theroritcall air flow 
   */
  getTheoriticalAirFlow(displacement: number, rpm: number): number {
    const airFlow = ((1.2929 * displacement * rpm) / 120);
    return Math.round(airFlow * 100) / 100;
  }

  /**
   * returns true if the vechile is ready for emission testing
   */
  isReadyForEmissionTest(reportData): boolean {
    let result: any = {};
    let dataIndex = 0;
    let index = 0;
    reportData.forEach((element: string) => {
      if (element.indexOf('is ready for emissions testing') > -1 && dataIndex == 0) {
        dataIndex = index;
      }
      index++;
    });
    return dataIndex > 0 ? true : false;
  }

  numberToEnglish(amount): string {
    if (!amount) {
      return '';
    }
    var words = new Array();
    words[0] = '';
    words[1] = 'One';
    words[2] = 'Two';
    words[3] = 'Three';
    words[4] = 'Four';
    words[5] = 'Five';
    words[6] = 'Six';
    words[7] = 'Seven';
    words[8] = 'Eight';
    words[9] = 'Nine';
    words[10] = 'Ten';
    words[11] = 'Eleven';
    words[12] = 'Twelve';
    words[13] = 'Thirteen';
    words[14] = 'Fourteen';
    words[15] = 'Fifteen';
    words[16] = 'Sixteen';
    words[17] = 'Seventeen';
    words[18] = 'Eighteen';
    words[19] = 'Nineteen';
    words[20] = 'Twenty';
    words[30] = 'Thirty';
    words[40] = 'Forty';
    words[50] = 'Fifty';
    words[60] = 'Sixty';
    words[70] = 'Seventy';
    words[80] = 'Eighty';
    words[90] = 'Ninety';
    amount = amount.toString();
    var atemp = amount.split(".");
    var number = atemp[0].split(",").join("");
    var n_length = number.length;
    var words_string = "";
    if (n_length <= 9) {
      var n_array: any = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
      var received_n_array = new Array();
      for (var i = 0; i < n_length; i++) {
        received_n_array[i] = number.substr(i, 1);
      }
      let j: any;
      for (i = 9 - n_length, j = 0; i < 9; i++ , j++) {
        n_array[i] = received_n_array[j];
      }
      for (i = 0, j = 1; i < 9; i++ , j++) {
        if (i == 0 || i == 2 || i == 4 || i == 7) {
          if (n_array[i] == 1) {
            n_array[j] = 10 + parseInt(n_array[j]);
            n_array[i] = 0;
          }
        }
      }
      let value: any = "";
      for (i = 0; i < 9; i++) {
        if (i == 0 || i == 2 || i == 4 || i == 7) {
          value = n_array[i] * 10;
        } else {
          value = n_array[i];
        }
        if (value != 0) {
          words_string += words[value] + " ";
        }
        if ((i == 1 && value != 0) || (i == 0 && value != 0 && n_array[i + 1] == 0)) {
          words_string += "Crores ";
        }
        if ((i == 3 && value != 0) || (i == 2 && value != 0 && n_array[i + 1] == 0)) {
          words_string += "Lakhs ";
        }
        if ((i == 5 && value != 0) || (i == 4 && value != 0 && n_array[i + 1] == 0)) {
          words_string += "Thousand ";
        }
        if (i == 6 && value != 0 && (n_array[i + 1] != 0 && n_array[i + 2] != 0)) {
          words_string += "Hundred and ";
        } else if (i == 6 && value != 0) {
          words_string += "Hundred ";
        }
      }
      words_string = words_string.split("  ").join(" ");
    }
    return words_string;
  }
}



// WEBPACK FOOTER //
// ./src/providers/data-service/data-service.ts